import { createLocalStorageDef } from "@mirage-web/utils/local-storage";
import { redirect } from "@tanstack/react-router";
import { z } from "zod";

export const loginCredentialsSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
  userId: z.string(),
});
export type LoginCredentialsType = z.infer<typeof loginCredentialsSchema>;

export const loginCredentials = createLocalStorageDef(
  "oasis_login_credentials",
  loginCredentialsSchema
);

export const sessionStorageDef = createLocalStorageDef(
  "oasis_session_storage",
  z.object({
    sessionId: z.string(),
    justification: z.string(),
    expiresAt: z.number(),
  })
);

export function ensureSession() {
  if (isLocalOasisDevAuthEnabled()) {
    return;
  }

  const session = sessionStorageDef.get();
  if (!session) {
    throw redirect({ to: "/session", search: { redirectTo: window.location.pathname } });
  }

  if (session.expiresAt < Date.now()) {
    throw redirect({ to: "/session", search: { redirectTo: window.location.pathname } });
  }
}

export function isLocalOasisDevAuthEnabled() {
  if (!import.meta.env.DEV) {
    return false;
  }

  const capSrvApiUrl = import.meta.env.VITE_CAP_SRV_API_URL;
  if (!capSrvApiUrl) {
    return false;
  }

  try {
    const hostname = new URL(capSrvApiUrl).hostname;
    return hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1";
  } catch {
    return false;
  }
}
